module.exports = __webpack_public_path__ + "static/media/shopify-logo.d3dcfb2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/shopify-logo.svg
// module id = 722
// module chunks = 0